export default __webpack_public_path__ + "fcdcd392e10fdbfd0b1a38089571e99a.png";